// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"290253ff","629":"84760dd9","774":"d75e4e07","787":"45bbaa0e"}[chunkId] + ".chunk.js";
};